import {
  Place,
  PlaceOfAcceptance, PlaceOfDelivery, PlaceOfLoading, PlaceOfUnloading,
} from 'features/declaration/models/schemas/placesSchemas'
import { CreateOrUpdatePlaceRequest, PlaceResponse } from 'api/models'

export function toCreateOrUpdatePlaceRequest(placeOfUnloading: Place): CreateOrUpdatePlaceRequest {
  return {
    id: placeOfUnloading.id,
    location: placeOfUnloading.location,
    country: placeOfUnloading.country,
    unLocode: placeOfUnloading.unLocode,
    type: placeOfUnloading.type,
  }
}

export function parsePlaceOfLoading(placeResponse?: PlaceResponse | null): PlaceOfLoading {
  return {
    id: placeResponse?.id || null,
    country: placeResponse?.country ?? '',
    location: placeResponse?.location ?? '',
    unLocode: placeResponse?.unLocode ?? '',
    type: 'LOADING',
    deleted: false,
  }
}

export function parsePlaceOfUnloading(placeResponse?: PlaceResponse | null): PlaceOfUnloading {
  return {
    id: placeResponse?.id || null,
    country: placeResponse?.country ?? '',
    location: placeResponse?.location ?? '',
    unLocode: placeResponse?.unLocode ?? '',
    type: 'UNLOADING',
    deleted: false,
  }
}

export function parsePlaceOfDelivery(placeResponse?: PlaceResponse | null): PlaceOfDelivery {
  return {
    id: placeResponse?.id || null,
    country: placeResponse?.country ?? '',
    location: placeResponse?.location ?? '',
    unLocode: placeResponse?.unLocode ?? '',
    type: 'DELIVERY',
    deleted: false,
  }
}

export function parsePlaceOfAcceptance(placeResponse?: PlaceResponse | null): PlaceOfAcceptance {
  return {
    id: placeResponse?.id || null,
    country: placeResponse?.country ?? '',
    location: placeResponse?.location ?? '',
    unLocode: placeResponse?.unLocode ?? '',
    type: 'ACCEPTANCE',
    deleted: false,
  }
}
